export function handleFilterChangedEvent(event) {
	var actualFilter = gridSettings.api.getFilterModel();

	if (isEmptyObject(actualFilter)) {
		$('#grid-save-filter-form').addClass('hidden');
	} else {
		$('#grid-save-filter-form').removeClass('hidden');
	}

	if (actualGridFilterSettingsId > 0) {
		$('#grid-save-filter-form input').val($('#grid-filter-' + actualGridFilterSettingsId).html());
	} else {
		$('#grid-save-filter-form input').val('');
	}

	if (typeof(Storage) !== "undefined") {
		let filterKey = '/filter' + gridDataUrl;
		localStorage.setItem(filterKey, JSON.stringify(actualFilter));
	}

	gridSettings.api.deselectAll();
}

export function saveGridFilter() {
	let filterModel = gridSettings.api.getFilterModel();
	let filterName = $('#grid-save-filter-form input').val();

	if (filterName === '') {
		staticNotification.error('Název filtru nesmí být prázdný.');
		return false;
	}

	var filterId = (actualGridFilterSettingsId === null) ? 0 : actualGridFilterSettingsId;

	const formData = new FormData();
	formData.append('settings', JSON.stringify(filterModel));
	formData.append('identifier', gridDataUrl);
	formData.append('name', filterName);
	formData.append('_do', 'saveFilter');

	najaGlobal.makeRequest('POST', '/core/user/grid-settings/detail/' + filterId, formData);

	return false;
}

export function isEmptyObject(value) {
	return Object.keys(value).length === 0 && value.constructor === Object;
}

